import Plus from "./Plus";

export * from "./AlignCenter";
export * from "./AlignJustify";
export * from "./AlignLeft";
export * from "./AlignRight";
export * from "./Baseline";
export * from "./Bold";
export * from "./CaseLower";
export * from "./CaseSensitive";
export * from "./CaseUpper";
export * from "./ClipboardCheck";
export * from "./ClipboardList";
export * from "./ClipboardPen";
export * from "./ClipboardType";
export * from "./ClipboardX";
export * from "./CopyCheck";
export * from "./Eraser";
export * from "./Expand";
export * from "./Hash";
export * from "./Italic";
export * from "./Languages";
export * from "./LayoutList";
export * from "./LetterText";
export * from "./Ligature";
export * from "./List";
export * from "./ListCheck";
export * from "./ListChecks";
export * from "./ListCollapse";
export * from "./ListFilter";
export * from "./ListTodo";
export * from "./Logs";
export * from "./NotebookPen";
export * from "./NotebookText";
export * from "./NotepadText";
export * from "./NotepadTextDashed";
export * from "./PaintbrushVertical";
export * from "./PenOff";
export * from "./Pilcrow";
export * from "./PilcrowLeft";
export * from "./PilcrowRight";
export * from "./Quote";
export * from "./RectangleEllipsis";
export * from "./RemoveFormatting";
export * from "./Replace";
export * from "./ReplaceAll";
export * from "./Section";
export * from "./Space";
export * from "./SquareCode";
export * from "./SquarePen";
export * from "./SquarePilcrow";
export * from "./Strikethrough";
export * from "./Subscript";
export * from "./Superscript";
export * from "./TextQuote";
export * from "./TextSearch";
export * from "./Type";
export * from "./TypeOutline";
export * from "./Underline";
export * from "./Unlink";
export * from "./Unlink2";
export * from "./WholeWord";
export * from "./Copy";
export * from "./Plus";

export const Textt = {
  Plus,
};
